import React from "react";
import { FaCogs, FaSearch, FaChartLine, FaBrain } from "react-icons/fa";

export const TechnologyDisclosure = (props) => {
  return (
    <section id="technology" className="technology-section py-5">
      <div className="container">
        {/* Section Title */}
        <div
          className="section-title text-center mb-5"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <h2>{props.data ? props.data.title : "Loading..."}</h2>
          <p className="lead">
            {props.data ? props.data.paragraph : "Loading..."}
          </p>
        </div>

        {/* Bullet Points with Icons */}
        <div className="row text-center">
          {props.data
            ? props.data.points.map((point, i) => (
                <div
                  key={i}
                  className="col-md-6 col-lg-3 mb-4"
                  data-aos="zoom-in"
                  data-aos-delay={200 * i}
                >
                  <div className="tech-box p-4 shadow rounded h-100">
                    <div className="icon mb-3">
                      {i === 0 && <FaCogs size={40} color="#007bff" />}
                      {i === 1 && <FaSearch size={40} color="#28a745" />}
                      {i === 2 && <FaChartLine size={40} color="#ffc107" />}
                      {i === 3 && <FaBrain size={40} color="#dc3545" />}
                    </div>
                    <p>{point}</p>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </section>
  );
};
